var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentphoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 55,
    viewBox: "0 0 57 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 55,
    rx: 10,
    fill: "#F99E1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1338 22.7975V14.5748L11 12.3504L28.4351 7L45.8514 12.4349L42.4111 13.3926V16.5185C42.4111 16.5185 43.1161 16.4482 43.4263 17.6168V34.1035H40.4655V17.6162C40.4655 17.6162 40.7052 16.6585 41.4949 16.4333V13.7159L38.6892 14.589V22.3044C38.6892 22.3044 29.8495 28.0633 22.8146 18.7281C22.8146 18.7287 19.8959 19.0385 18.1338 22.7975Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4327 31.8926C30.6006 36.7583 25.9552 36.939 21.5173 31.8926C16.052 35.4315 13.5086 40.4199 13.5235 46.6762H43.3838C43.1583 40.1714 40.5077 35.2431 35.4327 31.8926ZM28.4165 46.2116L22.3212 36.1162C26.0916 39.6952 30.1295 39.9714 34.5022 36.1162L28.4165 46.2116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentphoto);
export default __webpack_public_path__ + "static/media/studentphoto.2cddccbc03a2efeeeeebbc2074a24404.svg";
export { ForwardRef as ReactComponent };